// -----------------------------------------------------------------------------
// Main scripts
// -----------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages = document.querySelectorAll("img.lazy");
  var lazyloadThrottleTimeout;

  function lazyload() {
    if (lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function () {
      var scrollTop = window.pageYOffset;
      lazyloadImages.forEach(function (img) {
        if (img.offsetTop < (window.innerHeight + scrollTop)) {
          img.src = img.dataset.src;
          img.classList.remove('lazy');
        }
      });
      if (lazyloadImages.length == 0) {
        document.removeEventListener("scroll", lazyload);
        window.removeEventListener("resize", lazyload);
        window.removeEventListener("orientationChange", lazyload);
      }
    }, 20);
  }

  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);

  smallMenu();
});



$(document).ready(function () {

  // Instagram gallery
  // instaGallery();

  // Pop up
  popUp();

  // Menu scrollbar
  $('.rest-menu .dish-list').addClass('scrollbar-dynamic');

  $('.scrollbar-dynamic').scrollbar();

  // 100vh
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");

  // Smooth scroll
  $('a[href^="#"]').on('click', function (event) {

    var target = $(this.getAttribute('href'));

    if (target.length) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top - 100
      }, 1000);
    }
  });

  // Slider
  var mainSlider = function (el) {
    el.slick({
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      dots: true,
      accessibility: false,
      arrows: false,
    });
  };

  if ($("#slider").length > 0) {
    mainSlider($("#slider"));
  }



  // Slider with special offers
  var specOffer = function (el) {
    el.slick({
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      dots: false,
      accessibility: false,
      arrows: false,
    });
  };

  if ($("#spec-offer").length > 0) {
    specOffer($("#spec-offer"));
  }


  // Section with toggle button
  toggleButtons();


  // Left position for slider social media and galleri height
  function elementPosition() {
    var socialPosition = $('.header__lang').offset().left;
    var counterPosition = ($(window).width() - ($('.header__contact').offset().left + $('.header__contact').outerWidth()));

    $('.slider__social-media').css({
      'left': socialPosition
    });
    $('.slider__counter').css({
      'right': counterPosition
    });
    $('.slick-dots').css({
      'right': counterPosition
    });

  }
  $(function () {
    $(window).resize(elementPosition).trigger('resize');
  });


  // Sticky header
  stickyHeader();
  $(window).on('scroll', function () {

    stickyHeader();
  });


  // Navbar toggler btn
  menuMobile();

  // Height gallery
  if ($('.gallery__img-wrapper').length > 1) {

    var lastItem = $('.gallery__img-wrapper').last();
    var lastItemOff = lastItem.offset().top;
    var galleryOff = $('.gallery__inner').offset().top;
    var myOff = lastItemOff - galleryOff;
    var lastItemHeight = lastItem.outerHeight();
    var finalOff = myOff + lastItemHeight;

    $('.gallery__inner').css({
      'height': finalOff
    });
  } else {
    $('.gallery__inner').css({
      'height': 'auto'
    });
  }

});

// Section with toggle button
function toggleButtons() {
  $(".toggle").each(function () {
    $(this).children('.toggle__btn').on("click", function () {

      var selectedBtn = $(this);
      var selectedToggle = $(this).parent();

      if (selectedToggle.hasClass('toggle--open')) {
        selectedToggle.removeClass('toggle--open');
        selectedBtn.removeClass('toggle__btn--active');
      } else {
        selectedBtn.addClass('toggle__btn--active');
        selectedToggle.addClass('toggle--open').siblings('.toggle.toggle--open').removeClass('toggle--open');
        selectedToggle.siblings('.toggle').children('.toggle__btn.toggle__btn--active').removeClass('toggle__btn--active');
      }

      if ($('.menu__btn').hasClass('toggle__btn--active')) {
        $('.menu__title').hide();
        $('.menu__title-active').show();
      } else {
        $('.menu__title').show();
        $('.menu__title-active').hide();
      }
    });
  });
}

// Menu mobile
function menuMobile() {
  $('.header__btn').on('click', function () {
    $(this).toggleClass('active');
    $('.header').toggleClass('header--mobile');
    $('.menu.toggle').slideToggle("slow");
    $('.menu.toggle').toggleClass('menu--active');
    $('.menu__content').toggleClass('menu__content--active').slideToggle("slow");
  });
}


// 100vh
$(window).resize(function () {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");


  if ($('.gallery__img-wrapper').length > 1) {

    var lastItem = $('.gallery__img-wrapper').last();
    var lastItemOff = lastItem.offset().top;
    var galleryOff = $('.gallery__inner').offset().top;
    var myOff = lastItemOff - galleryOff;
    var lastItemHeight = lastItem.outerHeight();
    var finalOff = myOff + lastItemHeight;

    $('.gallery__inner').css({
      'height': finalOff
    });
  } else {
    $('.gallery__inner').css({
      'height': 'auto'
    });
  }
});


// Sticky header
function stickyHeader() {
  if ($(window).scrollTop() > 150) {
    $('.header').addClass('header--sticky');
  } else {
    $('.header').removeClass('header--sticky');
  }
}

// Close small menu popup on click
function smallMenu() {
  $('.small-menu__close').on('click', function () {
    $('.small-menu').fadeOut('slow');
  });
}